module.exports = __webpack_public_path__ + "static/img/loder.ee947fa.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loder.gif
// module id = mkX7
// module chunks = 1